/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AsistenciaRouteImport } from './routes/asistencia';
import { Route as AvisoDePrivacidadRouteImport } from './routes/aviso-de-privacidad';
import { Route as CodigoRouteImport } from './routes/codigo';
import { Route as CuentaInactivaRouteImport } from './routes/cuenta-inactiva';
import { Route as DispositivoNoRegistradoRouteImport } from './routes/dispositivo-no-registrado';
import { Route as InstalarRouteImport } from './routes/instalar';
import { Route as ListoRouteImport } from './routes/listo';
import { Route as MarcarRouteImport } from './routes/marcar';
import { Route as PerfilRouteImport } from './routes/perfil';
import { Route as RegistrarRouteImport } from './routes/registrar';
import { Route as ServicioSuspendidoRouteImport } from './routes/servicio-suspendido';
import { Route as ActivarTokenRouteImport } from './routes/activar.$token';
import { Route as JustificarDayRouteImport } from './routes/justificar.$day';
import { Route as RegularizarMarkIdRouteImport } from './routes/regularizar.$markId';
import { Route as SolicitudRefRouteImport } from './routes/solicitud.$ref';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AsistenciaRoute = AsistenciaRouteImport.update({
  id: '/asistencia',
  path: '/asistencia',
  getParentRoute: () => rootRouteImport,
} as any);
const AvisoDePrivacidadRoute = AvisoDePrivacidadRouteImport.update({
  id: '/aviso-de-privacidad',
  path: '/aviso-de-privacidad',
  getParentRoute: () => rootRouteImport,
} as any);
const CodigoRoute = CodigoRouteImport.update({
  id: '/codigo',
  path: '/codigo',
  getParentRoute: () => rootRouteImport,
} as any);
const CuentaInactivaRoute = CuentaInactivaRouteImport.update({
  id: '/cuenta-inactiva',
  path: '/cuenta-inactiva',
  getParentRoute: () => rootRouteImport,
} as any);
const DispositivoNoRegistradoRoute = DispositivoNoRegistradoRouteImport.update({
  id: '/dispositivo-no-registrado',
  path: '/dispositivo-no-registrado',
  getParentRoute: () => rootRouteImport,
} as any);
const InstalarRoute = InstalarRouteImport.update({
  id: '/instalar',
  path: '/instalar',
  getParentRoute: () => rootRouteImport,
} as any);
const ListoRoute = ListoRouteImport.update({
  id: '/listo',
  path: '/listo',
  getParentRoute: () => rootRouteImport,
} as any);
const MarcarRoute = MarcarRouteImport.update({
  id: '/marcar',
  path: '/marcar',
  getParentRoute: () => rootRouteImport,
} as any);
const PerfilRoute = PerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => rootRouteImport,
} as any);
const RegistrarRoute = RegistrarRouteImport.update({
  id: '/registrar',
  path: '/registrar',
  getParentRoute: () => rootRouteImport,
} as any);
const ServicioSuspendidoRoute = ServicioSuspendidoRouteImport.update({
  id: '/servicio-suspendido',
  path: '/servicio-suspendido',
  getParentRoute: () => rootRouteImport,
} as any);
const ActivarTokenRoute = ActivarTokenRouteImport.update({
  id: '/activar/$token',
  path: '/activar/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const JustificarDayRoute = JustificarDayRouteImport.update({
  id: '/justificar/$day',
  path: '/justificar/$day',
  getParentRoute: () => rootRouteImport,
} as any);
const RegularizarMarkIdRoute = RegularizarMarkIdRouteImport.update({
  id: '/regularizar/$markId',
  path: '/regularizar/$markId',
  getParentRoute: () => rootRouteImport,
} as any);
const SolicitudRefRoute = SolicitudRefRouteImport.update({
  id: '/solicitud/$ref',
  path: '/solicitud/$ref',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/asistencia': typeof AsistenciaRoute;
  '/aviso-de-privacidad': typeof AvisoDePrivacidadRoute;
  '/codigo': typeof CodigoRoute;
  '/cuenta-inactiva': typeof CuentaInactivaRoute;
  '/dispositivo-no-registrado': typeof DispositivoNoRegistradoRoute;
  '/instalar': typeof InstalarRoute;
  '/listo': typeof ListoRoute;
  '/marcar': typeof MarcarRoute;
  '/perfil': typeof PerfilRoute;
  '/registrar': typeof RegistrarRoute;
  '/servicio-suspendido': typeof ServicioSuspendidoRoute;
  '/activar/$token': typeof ActivarTokenRoute;
  '/justificar/$day': typeof JustificarDayRoute;
  '/regularizar/$markId': typeof RegularizarMarkIdRoute;
  '/solicitud/$ref': typeof SolicitudRefRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/asistencia': typeof AsistenciaRoute;
  '/aviso-de-privacidad': typeof AvisoDePrivacidadRoute;
  '/codigo': typeof CodigoRoute;
  '/cuenta-inactiva': typeof CuentaInactivaRoute;
  '/dispositivo-no-registrado': typeof DispositivoNoRegistradoRoute;
  '/instalar': typeof InstalarRoute;
  '/listo': typeof ListoRoute;
  '/marcar': typeof MarcarRoute;
  '/perfil': typeof PerfilRoute;
  '/registrar': typeof RegistrarRoute;
  '/servicio-suspendido': typeof ServicioSuspendidoRoute;
  '/activar/$token': typeof ActivarTokenRoute;
  '/justificar/$day': typeof JustificarDayRoute;
  '/regularizar/$markId': typeof RegularizarMarkIdRoute;
  '/solicitud/$ref': typeof SolicitudRefRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/asistencia': typeof AsistenciaRoute;
  '/aviso-de-privacidad': typeof AvisoDePrivacidadRoute;
  '/codigo': typeof CodigoRoute;
  '/cuenta-inactiva': typeof CuentaInactivaRoute;
  '/dispositivo-no-registrado': typeof DispositivoNoRegistradoRoute;
  '/instalar': typeof InstalarRoute;
  '/listo': typeof ListoRoute;
  '/marcar': typeof MarcarRoute;
  '/perfil': typeof PerfilRoute;
  '/registrar': typeof RegistrarRoute;
  '/servicio-suspendido': typeof ServicioSuspendidoRoute;
  '/activar/$token': typeof ActivarTokenRoute;
  '/justificar/$day': typeof JustificarDayRoute;
  '/regularizar/$markId': typeof RegularizarMarkIdRoute;
  '/solicitud/$ref': typeof SolicitudRefRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/asistencia'
    | '/aviso-de-privacidad'
    | '/codigo'
    | '/cuenta-inactiva'
    | '/dispositivo-no-registrado'
    | '/instalar'
    | '/listo'
    | '/marcar'
    | '/perfil'
    | '/registrar'
    | '/servicio-suspendido'
    | '/activar/$token'
    | '/justificar/$day'
    | '/regularizar/$markId'
    | '/solicitud/$ref';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/asistencia'
    | '/aviso-de-privacidad'
    | '/codigo'
    | '/cuenta-inactiva'
    | '/dispositivo-no-registrado'
    | '/instalar'
    | '/listo'
    | '/marcar'
    | '/perfil'
    | '/registrar'
    | '/servicio-suspendido'
    | '/activar/$token'
    | '/justificar/$day'
    | '/regularizar/$markId'
    | '/solicitud/$ref';
  id:
    | '__root__'
    | '/'
    | '/asistencia'
    | '/aviso-de-privacidad'
    | '/codigo'
    | '/cuenta-inactiva'
    | '/dispositivo-no-registrado'
    | '/instalar'
    | '/listo'
    | '/marcar'
    | '/perfil'
    | '/registrar'
    | '/servicio-suspendido'
    | '/activar/$token'
    | '/justificar/$day'
    | '/regularizar/$markId'
    | '/solicitud/$ref';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AsistenciaRoute: typeof AsistenciaRoute;
  AvisoDePrivacidadRoute: typeof AvisoDePrivacidadRoute;
  CodigoRoute: typeof CodigoRoute;
  CuentaInactivaRoute: typeof CuentaInactivaRoute;
  DispositivoNoRegistradoRoute: typeof DispositivoNoRegistradoRoute;
  InstalarRoute: typeof InstalarRoute;
  ListoRoute: typeof ListoRoute;
  MarcarRoute: typeof MarcarRoute;
  PerfilRoute: typeof PerfilRoute;
  RegistrarRoute: typeof RegistrarRoute;
  ServicioSuspendidoRoute: typeof ServicioSuspendidoRoute;
  ActivarTokenRoute: typeof ActivarTokenRoute;
  JustificarDayRoute: typeof JustificarDayRoute;
  RegularizarMarkIdRoute: typeof RegularizarMarkIdRoute;
  SolicitudRefRoute: typeof SolicitudRefRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/asistencia': {
      id: '/asistencia';
      path: '/asistencia';
      fullPath: '/asistencia';
      preLoaderRoute: typeof AsistenciaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/aviso-de-privacidad': {
      id: '/aviso-de-privacidad';
      path: '/aviso-de-privacidad';
      fullPath: '/aviso-de-privacidad';
      preLoaderRoute: typeof AvisoDePrivacidadRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/codigo': {
      id: '/codigo';
      path: '/codigo';
      fullPath: '/codigo';
      preLoaderRoute: typeof CodigoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/cuenta-inactiva': {
      id: '/cuenta-inactiva';
      path: '/cuenta-inactiva';
      fullPath: '/cuenta-inactiva';
      preLoaderRoute: typeof CuentaInactivaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/dispositivo-no-registrado': {
      id: '/dispositivo-no-registrado';
      path: '/dispositivo-no-registrado';
      fullPath: '/dispositivo-no-registrado';
      preLoaderRoute: typeof DispositivoNoRegistradoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/instalar': {
      id: '/instalar';
      path: '/instalar';
      fullPath: '/instalar';
      preLoaderRoute: typeof InstalarRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/listo': {
      id: '/listo';
      path: '/listo';
      fullPath: '/listo';
      preLoaderRoute: typeof ListoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/marcar': {
      id: '/marcar';
      path: '/marcar';
      fullPath: '/marcar';
      preLoaderRoute: typeof MarcarRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/perfil': {
      id: '/perfil';
      path: '/perfil';
      fullPath: '/perfil';
      preLoaderRoute: typeof PerfilRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/registrar': {
      id: '/registrar';
      path: '/registrar';
      fullPath: '/registrar';
      preLoaderRoute: typeof RegistrarRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/servicio-suspendido': {
      id: '/servicio-suspendido';
      path: '/servicio-suspendido';
      fullPath: '/servicio-suspendido';
      preLoaderRoute: typeof ServicioSuspendidoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/activar/$token': {
      id: '/activar/$token';
      path: '/activar/$token';
      fullPath: '/activar/$token';
      preLoaderRoute: typeof ActivarTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/justificar/$day': {
      id: '/justificar/$day';
      path: '/justificar/$day';
      fullPath: '/justificar/$day';
      preLoaderRoute: typeof JustificarDayRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/regularizar/$markId': {
      id: '/regularizar/$markId';
      path: '/regularizar/$markId';
      fullPath: '/regularizar/$markId';
      preLoaderRoute: typeof RegularizarMarkIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/solicitud/$ref': {
      id: '/solicitud/$ref';
      path: '/solicitud/$ref';
      fullPath: '/solicitud/$ref';
      preLoaderRoute: typeof SolicitudRefRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AsistenciaRoute: AsistenciaRoute,
  AvisoDePrivacidadRoute: AvisoDePrivacidadRoute,
  CodigoRoute: CodigoRoute,
  CuentaInactivaRoute: CuentaInactivaRoute,
  DispositivoNoRegistradoRoute: DispositivoNoRegistradoRoute,
  InstalarRoute: InstalarRoute,
  ListoRoute: ListoRoute,
  MarcarRoute: MarcarRoute,
  PerfilRoute: PerfilRoute,
  RegistrarRoute: RegistrarRoute,
  ServicioSuspendidoRoute: ServicioSuspendidoRoute,
  ActivarTokenRoute: ActivarTokenRoute,
  JustificarDayRoute: JustificarDayRoute,
  RegularizarMarkIdRoute: RegularizarMarkIdRoute,
  SolicitudRefRoute: SolicitudRefRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
